// backend/src/lib/roles.ts と対応するロール定義 + UI 表示用メタデータ。
export type Role = 'admin' | 'user';

export const ROLES: readonly Role[] = ['admin', 'user'] as const;

export interface RoleMeta {
  /** UI 表示ラベル（日本語） */
  label: string;
  /** ロールの説明（ツールチップや詳細画面用） */
  description: string;
  /** バッジ用の CSS クラス（global.css に対応する `.badge--role-*` を追加する） */
  badgeClass: string;
  /** true の場合、管理コンソールのロール編集 UI で明示的にトグルできる */
  editable: boolean;
}

export const ROLE_META: Record<Role, RoleMeta> = {
  admin: {
    label: '管理者',
    description: '管理コンソールへのアクセスと全ユーザー・全開発者への操作権限を持ちます。',
    badgeClass: 'badge--role-admin',
    editable: true,
  },
  user: {
    label: '一般ユーザー',
    description: '全ての Cognito ユーザーが持つ基本ロール。個別に付与・剥奪はできません。',
    badgeClass: 'badge--role-user',
    editable: false, // 全ユーザー共通なので UI では disabled
  },
};

export function isRole(value: unknown): value is Role {
  return typeof value === 'string' && (ROLES as readonly string[]).includes(value);
}
